import React from "react";
import { Box, Button, Flex, Select, Text, Icon, useColorModeValue } from "@chakra-ui/react";
import { MdRestartAlt } from "react-icons/md";
import {
    STATUS_FILTER_OPTIONS,
    OWNER_TYPE_FILTER_OPTIONS,
    TIER_FILTER_OPTIONS,
    PROVIDER_FILTER_OPTIONS,
} from "./subscriptionsManageConstants";

/**
 * Generic labelled Select used by all three filters.
 * Calls onChange with the new value; the parent resets page=1.
 * @param {Object} props - Filter select props
 * @returns {React.ReactElement}
 */
function FilterSelect({ label, value, options, onChange }) {
    const labelColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <Box>
            <Text color={labelColor} fontSize="0.65rem" textTransform="uppercase" letterSpacing="0.5px" fontWeight="700" mb="4px">{label}</Text>
            <Select size="sm" borderRadius="8px" minW="180px" value={value} onChange={(e) => onChange(e.target.value)}>
                {options.map((opt) => (<option key={opt.value || "__all"} value={opt.value}>{opt.label}</option>))}
            </Select>
        </Box>
    );
}

/**
 * Builds the new filters object when a single field changes.
 * Page is always reset to 1 since a filter change can shrink/grow the result set.
 * @param {Object} current - Current filters
 * @param {string} field - Field name to update
 * @param {string} value - New value
 * @returns {Object} Updated filters
 */
function updateFilters(current, field, value) {
    return { ...current, [field]: value, page: 1 };
}

/**
 * Filter row with status, owner_type and subscription_type selects plus a reset button.
 * @param {Object} props
 * @param {Object} props.filters - Current filters object
 * @param {Function} props.onChange - Called with the new filters object
 * @returns {React.ReactElement}
 */
function SubscriptionsFilters({ filters, onChange }) {
    const handleReset = () => onChange({ status: "", owner_type: "", subscription_type: "", payment_provider: "", page: 1 });
    return (
        <Flex gap="12px" flexWrap="wrap" align="flex-end" justify="space-between">
            <Flex gap="12px" flexWrap="wrap" align="flex-end" flex="1">
                <FilterSelect label="Statut" value={filters.status || ""} options={STATUS_FILTER_OPTIONS}
                    onChange={(v) => onChange(updateFilters(filters, "status", v))} />
                <FilterSelect label="Propriétaire" value={filters.owner_type || ""} options={OWNER_TYPE_FILTER_OPTIONS}
                    onChange={(v) => onChange(updateFilters(filters, "owner_type", v))} />
                <FilterSelect label="Type" value={filters.subscription_type || ""} options={TIER_FILTER_OPTIONS}
                    onChange={(v) => onChange(updateFilters(filters, "subscription_type", v))} />
                <FilterSelect label="Paiement" value={filters.payment_provider || ""} options={PROVIDER_FILTER_OPTIONS}
                    onChange={(v) => onChange(updateFilters(filters, "payment_provider", v))} />
            </Flex>
            <Button onClick={handleReset} size="sm" variant="outline" leftIcon={<Icon as={MdRestartAlt} />}>Réinitialiser</Button>
        </Flex>
    );
}

export default SubscriptionsFilters;
